import { render, staticRenderFns } from "./addWorkLogic.vue?vue&type=template&id=45e2fd97&scoped=true&"
import script from "./addWorkLogic.vue?vue&type=script&lang=js&"
export * from "./addWorkLogic.vue?vue&type=script&lang=js&"
import style0 from "./addWorkLogic.vue?vue&type=style&index=0&id=45e2fd97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2fd97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e2fd97')) {
      api.createRecord('45e2fd97', component.options)
    } else {
      api.reload('45e2fd97', component.options)
    }
    module.hot.accept("./addWorkLogic.vue?vue&type=template&id=45e2fd97&scoped=true&", function () {
      api.rerender('45e2fd97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/work-order/work-order-rule/addWorkLogic.vue"
export default component.exports